import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';

import {
  goToPage,
  navigateTo,
  reportAnalytics,
  setSelectedAddress,
  setIsSubmit,
  setIsValid,
  setError,
  reportAddressNotConnectedToFiber,
} from '../saleBlockSlice';
import AddressFrm from '../../../Shared/AddressFrm/AddressFrm';
import { getRecaptchaToken } from './../../../../utilities/recaptcha/recaptcha';
import { getFormatDateWithTime } from './../../../../utilities/dateUtils';
import Config from '../../../../Config';
import ProviderManager from '../../../../provider/providerManager';
import { sessionSet as leadSessionSet } from '../../../../utilities/leadStorageAPI/sessionStorageAPI';
import { eSimSaleType } from '../Esim/esimEnums';

const AddressPage = (props) => {
  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({ eventCategory: 'tv_newsale_process', eventAction: 'visibility_17', eventLabel: eventLabel });
        break;
      case 'cellular':
        props.reportAnalytics({ eventCategory: 'cellular_newsale_process', eventAction: 'visibility_21', eventLabel: 'screen_11' });
        break;
      case 'internet':
        props.reportAnalytics({ eventCategory: 'fiber_newsale_process', eventAction: 'visibility_1', eventLabel: 'screen_1' });
        break;
    }
  }, []);

  let saleType = props.saleType;
  let flowType = props.flowType;

  //page params
  let isDisplayFooter = true;
  let btnText = 'לבחירת אופן התקנה';
  let currentPageFunction = handleAddressFormPageContinue;
  let totalPrice = saleType != 'internet' ? props.totalPrice : null;
  let totalPriceOneTime = props.totalPriceOneTime;
  let priceText = 'לחודש';
  let formid = 'sale';

  let isCheckFiberAddress = saleType == 'internet';
  //page params

  let title = '';
  let subTitle = '';
  let innerBoxTitle = null;

  switch (saleType) {
    case 'tv':
      title = `באיזו כתובת תרצו להתקין את ${window.Config.brand_Name_HE} TV?`;
      break;
    case 'cellular':
      if (props.productsInfo.baseProduct?.isDisplaySimActivation) {
        title = 'כתובת מגורים';
        subTitle = '';
        btnText = 'המשך';
        innerBoxTitle = 'כתובת מגורים';
      } else if (props.esim?.isRegularSimClicked && props.saleFlowType == 'newCustomer') {
        title = 'לאן לשלוח את ה-SIM?';
        subTitle = 'מלאו את הכתובת ונתאם לכם משלוח ללא עלות';
        btnText = 'לבחירת שעת הגעת השליח';
        innerBoxTitle = 'כתובת למשלוח';
      } else {
        title = 'כתובת מגורים';
        subTitle = '';
        btnText = 'המשך';
        innerBoxTitle = 'כתובת מגורים';
      }
      break;
    case 'internet':
      title = 'בואו נבדוק שיש לכם תשתית סיבים';
      btnText = 'לבדיקה';
      break;
  }
  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> {title} </h1>
      <h2 className='sale-title-small'> {subTitle} </h2>
    </div>
  );

  let currentPageView = (
    <AddressFrm
      onError={handleOnError}
      title={innerBoxTitle}
      saleType={saleType}
      onValid={handleAddressValidate}
      onSubmit={props.isSubmit}
      isCheckFiberAddress={isCheckFiberAddress}
    />
  );

  function handleAddressFormPageContinue() {
    props.setIsSubmit({ isSubmit: true });
  }

  function handleAddressValidate(valid) {
    props.setIsSubmit({ isSubmit: false });
    if (valid) {
      handleAddressFormPageContinueAfterValid();
    }
    props.setIsSubmit({ isSubmit: false });
  }

  async function handleAddressFormPageContinueAfterValid() {
    const address = {
      city: props._address.city,
      cityName: props._address.cityName,
      street: props._address.street,
      streetName: props._address.streetName,
      home: props._address.home,
      apartment: props._address.apartment,
      enter: props._address.enter,
      zipCode: props._address.zipCode,
      technicianHours: props._address.technicianHours,
      infrastructure: {
        tashtitType: props._infrastructure.tashtitType,
        custStatus: props._infrastructure.custStatus,
        assetMarketStatus: props._infrastructure.assetMarketStatus,
        assetDateSalesTarget: props._infrastructure.assetDateSalesTarget,
        gponBuildingType: props._infrastructure.gponBuildingType,
        distributionType: props._infrastructure.distributionType,
        infrastructure: props._infrastructure.infrastructure,
      },
    };
    props.setSelectedAddress({ selectedAddress: address });

    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({ eventCategory: 'tv_newsale_process', eventAction: 'click_24', eventLabel: eventLabel });
        break;
      case 'cellular':
        props.reportAnalytics({ eventCategory: 'cellular_newsale_process', eventAction: 'click_43', eventLabel: 'button_11' });
        break;
      case 'internet':
        props.reportAnalytics({ eventCategory: 'fiber_newsale_process', eventAction: 'click_1', eventLabel: 'button_1' });
        break;
    }

    if (saleType == 'internet') {
      const isAddressConnectedToFiber =
        address.infrastructure.tashtitType == 'FIBER' ||
        address.infrastructure.tashtitType == 'IBC' ||
        address.infrastructure.tashtitType == 'BF';
      const isBeforeConnection = address.infrastructure.assetMarketStatus == 'בניין לקראת חיבור';
      const connectionDate = new Date(address.infrastructure.assetDateSalesTarget);
      const today = new Date();
      const maxDate = addDays(today, 60);
      const urlLead = props.saleBlockData.urlLead;

      if (isAddressConnectedToFiber == false || (isBeforeConnection && connectionDate > maxDate)) {
        props.reportAddressNotConnectedToFiber({ address: address });
        props.navigateTo();
        leadSessionSet({ from: 'fiberNewSale', productName: eventLabel, address: address });
        props.context.navigateTo(urlLead);
        return;
      }
      props.goToPage({ page: 'loginPage', percent: 24 });
      return;
    }

    //----------------------------------------------------------------------------------
    let pageData = {};
    if (!props.configuration.isAllowTechnitian && !props.configuration.isAllowDelivery) {
      switch (saleType) {
        case 'tv':
          pageData = { page: 'otpVerifyPhone', percent: 36 };
          break;
        case 'cellular':
          if (
            props.esim?.saleType == eSimSaleType.eSimOnly &&
            props.saleFlowType == 'newCustomer' &&
            !props.authentication?.loginData?.isFullAuthenticated
          ) {
            pageData = { page: 'otpVerifyPhone', percent: 36 };
          } else if (props.esim?.saleType == eSimSaleType.eSimOnly) {
            pageData = { page: 'emailPage', percent: 40 };
          } else {
            pageData = { page: 'deliveryAddressPage', percent: 40 };
          }
          break;
      }
    }
    if (props.configuration.isAllowDelivery) {
      switch (saleType) {
        case 'tv':
          pageData = { page: 'deliveryAddressPage', percent: 36 };
          break;
        case 'cellular':
          if (
            props.esim?.saleType == eSimSaleType.eSimOnly &&
            props.saleFlowType == 'newCustomer' &&
            !props.authentication?.loginData?.isFullAuthenticated
          ) {
            pageData = { page: 'otpVerifyPhone', percent: 60 };
          } else if (props.esim?.saleType == eSimSaleType.eSimOnly) {
            pageData = { page: 'emailPage', percent: 40 };
          } else {
            pageData = { page: 'deliveryAddressPage', percent: 40 };
          }
          break;
      }
    }
    if (props.configuration.isAllowTechnitian) {
      switch (saleType) {
        case 'tv':
          let result = await getTechnicianSlots();

          if (!result) {
            if (props.configuration.isAllowDelivery) pageData = { page: 'deliveryAddressPage', percent: 36 };
            break;
          }
          pageData = { page: 'technicianPage', percent: 36 };
          break;
        case 'cellular':
          if (
            props.esim?.saleType == eSimSaleType.eSimOnly &&
            props.saleFlowType == 'newCustomer' &&
            !props.authentication?.loginData?.isFullAuthenticated
          ) {
            pageData = { page: 'otpVerifyPhone', percent: 60 };
          } else if (props.esim?.saleType == eSimSaleType.eSimOnly) {
            pageData = { page: 'emailPage', percent: 40 };
          } else {
            pageData = { page: 'deliveryAddressPage', percent: 40 };
          }
          break;
      }
    }
    props.goToPage(pageData);
    //----------------------------------------------------------------------------------
  }

  async function getTechnicianSlots() {
    const token = await getRecaptchaToken('addressPage');
    const result = await getSlots(token);
    return result;
  }

  async function getSlots(recaptchaToken) {
    const address = {
      city: props._address.city,
      cityName: props._address.cityName,
      street: props._address.street,
      streetName: props._address.streetName,
      home: props._address.home,
      apartment: props._address.apartment,
      enter: props._address.enter,
      zipCode: props._address.zipCode,
      technicianHours: props._address.technicianHours,
      infrastructure: {
        tashtitType: props._infrastructure.tashtitType,
        custStatus: props._infrastructure.custStatus,
        assetMarketStatus: props._infrastructure.assetMarketStatus,
        assetDateSalesTarget: props._infrastructure.assetDateSalesTarget,
        gponBuildingType: props._infrastructure.gponBuildingType,
        distributionType: props._infrastructure.distributionType,
        infrastructure: props._infrastructure.infrastructure,
      },
    };

    const isBeforeConnection = address.infrastructure.assetMarketStatus == 'בניין לקראת חיבור';
    const connectionDate = new Date(address.infrastructure.assetDateSalesTarget);
    const today = new Date();
    const maxDate = addDays(today, 60);
    const token = recaptchaToken;
    let params = {};
    let typeName = Config.isTimeSlotsGetFromClick ? 'התקנת TV' : 'התקנת IPTV';
    let isTimeSlotsFromDate = false;

    if (address.infrastructure.tashtitType == 'IBC') {
      typeName = 'התקנת תשתית IBC';
    }

    if (address.infrastructure.tashtitType == 'FIBER' || address.infrastructure.tashtitType == 'BF') {
      typeName = 'התקנת תשתית סיבים';
    }

    if (isBeforeConnection && connectionDate < maxDate) {
      isTimeSlotsFromDate = true;

      params = {
        city: address.cityName,
        zipCode: address.zipCode,
        typeName: typeName,
        cityCode: address.city,
        streetCode: address.street,
        entrance: address.enter == '' ? ' ' : address.enter,
        fromDate: addDays(address.infrastructure.assetDateSalesTarget, 2), //2020-11-30T00:00:00+02:00
        addDays: '12',
        captchaToken: token,
        otpTicketId: props.saleOtpTicketId,
        flowType: props.saleFlowType,
        otpPhone: props.saleOtpPhone,
        distributionType: address.infrastructure.distributionType,
        infrastructure: address.infrastructure.infrastructure,
      };
    } else {
      params = {
        city: address.cityName,
        zipCode: address.zipCode,
        cityCode: address.city,
        streetCode: address.street,
        entrance: address.enter == '' ? ' ' : address.enter,
        typeName: typeName,
        captchaToken: token,
        otpTicketId: props.saleOtpTicketId,
        flowType: props.saleFlowType,
        otpPhone: props.saleOtpPhone,
        distributionType: address.infrastructure.distributionType,
        infrastructure: address.infrastructure.infrastructure,
      };
    }

    try {
      let result;

      if (isTimeSlotsFromDate) {
        result = await ProviderManager.getProviderData('getTimeSlotsFromDate', [
          getFormatDateWithTime(params.fromDate),
          params.city,
          params.cityCode,
          params.streetCode,
          params.entrance,
          params.typeName,
          '322',
          params.zipCode,
          params.addDays,
          params.captchaToken,
          '0',
          '0',
          null,
          null,
        ]);
      } else {
        result = await ProviderManager.getProviderData('getTimeSlots', [
          params.city,
          params.cityCode,
          params.streetCode,
          params.entrance,
          params.typeName,
          '322',
          params.zipCode,
          params.captchaToken,
          '0',
          '0',
          '48',
          null,
          null,
        ]);
      }

      if (result.Body) {
        if (result.errorCode != undefined && result.errorCode == 1200) {
          return false;
        }
      }

      return true;
    } catch (error) {
      console.info('time slot error', error);
      return null;
    }
  }

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function handleOnError(errorId) {
    props.setError({ isDisplay: true, id: errorId, isOpenWorkOrder: true });
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          totalPriceOneTime={totalPriceOneTime}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    configuration: state.saleBlock.epiServer.configuration,
    saleBlockData: state.saleBlock.epiServer.saleBlock,
    saleOtpTicketId: state.saleBlock.otpTicketId,
    saleFlowType: state.saleBlock.flowType,
    saleOtpPhone: state.saleBlock.otpPhone,
    productsInfo: state.saleBlock.productsInfo,
    esim: state.saleBlock.esim,
    //other states
    _address: state.addressForm.form,
    _infrastructure: state.addressForm.infrastructure,
    authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  navigateTo,
  reportAnalytics,
  setSelectedAddress,
  setIsSubmit,
  setIsValid,
  setError,
  reportAddressNotConnectedToFiber,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressPage);
